import moment from "moment"
import { Icon } from "semantic-ui-react"

import { InfoBoxWidget, InfoBoxWidgetTitleArea, InfoContainer, InfoItem, KeyFactLink } from "../Styles"

const CompanyBlog = ({ blogs }) => {
  if (!blogs?.length) return null
  return (
    <InfoBoxWidget>
      <InfoBoxWidgetTitleArea>
        <Icon name="newspaper" />
        <div>
          <h3>Blogs</h3>
          <span>{blogs.length} found</span>
        </div>
      </InfoBoxWidgetTitleArea>
      {blogs.map((blog) => (
        <>
          <h1>{blog?.title}</h1>
          <InfoContainer $wrapped>
            {blog?.entries?.map((blogPost) => (
              <InfoItem key={blogPost?._id} href={blogPost?.url}>
                <KeyFactLink
                  key={blogPost?.title}
                  title={blogPost?.title}
                  fact={
                    blogPost?.publishedAt
                      ? `Published: ${moment(blogPost?.publishedAt).format("YYYY-MM-DD HH:mm")}`
                      : null
                  }
                  image={blogPost?.imageUrl}
                  url={blogPost?.link}
                />
              </InfoItem>
            ))}
          </InfoContainer>
        </>
      ))}
    </InfoBoxWidget>
  )
}

export default CompanyBlog
